import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SaveChecklistAnswersMutation = graphql.persisted(
  "SaveChecklistAnswers",
  graphql(`
    mutation SaveChecklistAnswers($input: SaveChecklistAnswersInput!) {
      saveChecklistAnswers(input: $input) {
        answers
        errors
      }
    }
  `)
);

export { SaveChecklistAnswersMutation };

export function useSaveChecklistAnswers() {
  return useMutation(SaveChecklistAnswersMutation);
}
